import {
  SshSecurityInfoState,
  SshSecurityInfoActionTypes,
  GET_SSH_SECURITY_INFO_FULFILLED,
  GET_SSH_SECURITY_INFOS_LIST,
  GET_SSH_SECURITY_INFOS_LIST_FULFILLED,
  GET_SSH_SECURITY_INFOS_PENDING,
  GET_SSH_SECURITY_INFOS_FULFILLED,
  SELECT_SSH_SECURITY_INFOS,
  CREATE_SSH_SECURITY_INFOS_PENDING,
  CREATE_SSH_SECURITY_INFOS_FULFILLED,
  SET_SSH_SECURITY_INFOS_LOADING,
} from './sshSecurityInfo.types';

export const initialState: SshSecurityInfoState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function sshSecurityInfoReducer(
  state = initialState,
  action: SshSecurityInfoActionTypes,
): SshSecurityInfoState {
  switch (action.type) {
    case GET_SSH_SECURITY_INFOS_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_SSH_SECURITY_INFOS_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_SSH_SECURITY_INFOS_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_SSH_SECURITY_INFO_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case GET_SSH_SECURITY_INFOS_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data || []
      };

    case SELECT_SSH_SECURITY_INFOS:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_SSH_SECURITY_INFOS_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_SSH_SECURITY_INFOS_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case SET_SSH_SECURITY_INFOS_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
